import React from "react";
import { AUDITS } from "../../../core/theme/auditsTheme";

// The stage 1 Audits page's left column, for accounts without Industry
// Audits: placeholders until the "Your area" block (B2 stage 5).
export default function AuditsSidePanel() {
  return (
    <aside className={AUDITS.side}>
      <section>
        <h2 className={`${AUDITS.title} mb-3`}>Your area</h2>
        <div className={AUDITS.placeholder}>Your industry and area summary will appear here.</div>
      </section>
      <section>
        <h2 className={`${AUDITS.title} mb-3`}>What you have</h2>
        <div className={AUDITS.placeholder}>Suggested searches will appear here.</div>
      </section>
    </aside>
  );
}
